import React from "react";
import { useDispatch } from "react-redux";
import { Select } from "semantic-ui-react";

import * as actions from "../../../store/actions/actions";
import { reportTypes } from "../../../store/reducers/reports";

const selectOptionPlaceholderText = "Select ...";
const selectOptionDefaultText = "--";

const selectOptions = [
  { value: "", text: selectOptionDefaultText },
  {
    value: reportTypes.analyzeSegments.value,
    text: reportTypes.analyzeSegments.text,
  },
  {
    value: reportTypes.compareStores.value,
    text: reportTypes.compareStores.text,
  },
  {
    value: reportTypes.analyzeDailyPatterns.value,
    text: reportTypes.analyzeDailyPatterns.text,
  },
  {
    value: reportTypes.analyzeRecentTrends.value,
    text: reportTypes.analyzeRecentTrends.text,
  },
];

const ReportsSidePanelTypes = (props) => {
  const dispatch = useDispatch();
  const handleChange = (e, { value }) =>
    dispatch(actions.selectReportType(value));
  return (
    <Select
      id="analyzeSelect"
      className="reports-panel-select"
      placeholder={selectOptionPlaceholderText}
      options={selectOptions}
      onChange={handleChange}
    />
  );
};

export default React.memo(ReportsSidePanelTypes);
